import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { WINDOW } from '@eucoms/common-components';
import { Router } from '@angular/router';

import { FallbackReportService } from '@app/fallback-report/local-service/fallback-report.service';
import { constants } from '@app/constants';
import copy from './copy';

@Component({
  selector: 'app-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss']
})
export class MoreInfoComponent implements OnInit, AfterViewInit {
  currentOutageInfo: Array<any> = [];
  projectedRestCust: Array<any> = [];
  electricInfra: Array<any> = [];
  totalOutages = 0;
  dateExtended = new Date();

  copyBack = copy.back;
  copyStatic = copy.static;
  copyCOI = copy.COI;
  copyCPR = copy.CPR;
  copyEI = copy.EI;
  copyNoCOI = copy.noCOI;
  copyNoCPR = copy.noCPR;
  copyNoEI = copy.noEI;
  copyURP = copy.URP;
  copyFallbackURL = copy.fallbackURL;

  constructor(
    @Inject(WINDOW) private window: Window,
    private router: Router,
    private localService: FallbackReportService
  ) { }

  ngOnInit() {
    const data = this.localService.aceMoreData;

    if (data !== undefined && data.length > 0) {
      this.currentOutageInfo = data[0].currentOutageInfo;
      this.projectedRestCust = data[0].projectedRestCust;
      this.electricInfra = data[0].electricInfra;
      this.totalOutages = data[0].totalOutages;

      this.dateExtended.setDate(this.dateExtended.getDate() + 14);
    }
  }

  ngAfterViewInit() {
    try {
      const iframe = parent.document.getElementById('outageMapiFrame');
      iframe.scrollIntoView();
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }

  onClickBack() {
    this.localService.isShowMore = false;
    this.localService.aceMoreData = [];
  }

  onClickURP() {
    this.window.open(constants.stormRestorationProcessUrl, '_blank');
  }
}
